import { Controller } from "@hotwired/stimulus"

// Preserves row selection state across Turbo Stream updates
// The server doesn't know which row is selected during broadcasts,
// so we track it client-side and restore after Turbo replaces rows
export default class extends Controller {
  static targets = ["table"]

  connect() {
    // Get selected ID from URL on connect
    this.selectedId = this.getSelectedIdFromUrl()

    // Listen for Turbo Stream events to restore selection after updates
    document.addEventListener("turbo:before-stream-render", this.boundBeforeStreamRender = this.beforeStreamRender.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundBeforeStreamRender)
  }

  // Get selected ID from URL params
  getSelectedIdFromUrl() {
    const params = new URLSearchParams(window.location.search)
    return params.get("search_id")
  }

  // Before a Turbo Stream renders, capture the current selection
  // Debounced to avoid UI flickering from rapid updates
  beforeStreamRender(event) {
    // Debounce: ignore updates within 300ms of each other
    const now = Date.now()
    if (this.lastUpdate && now - this.lastUpdate < 300) {
      return
    }
    this.lastUpdate = now

    // After the stream renders, restore selection
    // Use setTimeout to ensure the DOM has been updated
    setTimeout(() => {
      this.restoreSelection()
    }, 10)
  }

  // Restore selection after Turbo update
  restoreSelection() {
    const selectedId = this.selectedId || this.getSelectedIdFromUrl()
    if (!selectedId) return

    // Find the row by ID
    const row = document.querySelector(`tr[data-id="${selectedId}"]`)
    if (!row) return

    // Check if row already has selection classes (server rendered correctly)
    if (row.classList.contains("bg-primary-50")) return

    // Add selection classes
    row.classList.add("bg-primary-50", "dark:bg-primary-900/20")

    // Update the link styling
    const link = row.querySelector('td[data-column="query"] a')
    if (link) {
      link.classList.add("font-semibold")
    }

    // Add viewing badge if not present
    const queryCell = row.querySelector('td[data-column="query"]')
    if (queryCell && !queryCell.querySelector('.text-primary-500')) {
      const badge = document.createElement('span')
      badge.className = 'ml-1 text-xs text-primary-500'
      badge.textContent = '(viewing)'
      const link = queryCell.querySelector('a')
      if (link) {
        link.parentNode.insertBefore(badge, link.nextSibling)
      }
    }
  }
}
